export default {
    list: { lazy: () => import('./PartnerRecords'), component: 'PartnerRecordList' },
    create: null,
    edit: null,
  }
  